export const multiSelectTheme = {
  list: {
    padding: 'var(--quarter-rem)',
    header: {
      padding:
        'var(--half-rem) var(--half-rem) var(--one-eighth-rem) var(--rem)',
    },
  },
  overlay: {
    borderRadius: 'var(--border-radius)',
  },
  extend: {
    agility: {
      custom: {
        height: 'var(--trigger-icon-rem)',
        width: 'var(--trigger-icon-rem)',
        borderWidth: '3px',
        background: 'var(--p-primary-500)',
        color: 'var(--p-primary-500)',
        borderColor: 'var(--p-primary-500)',
        borderHoverColor: 'var(--p-primary-500)',
        borderRadius: 'var(--pct-50)',
        hoverColor: 'var(--white)',
        hoverBackground: 'var(--p-primary-500)',
      },
    },
  },
  colorScheme: {
    light: {
      overlay: {
        background: 'var(--white)',
        shadow: 'var(--overlay-box-shadow)',
      },
      clearIcon: {
        color: '#94a3b8',
      },
      option: {
        selectedBackground: 'transparent',
      },
    },
    dark: {
      overlay: {
        background: 'var(--p-surface-900)',
        shadow: 'var(--overlay-box-shadow)',
      },
      clearIcon: {
        color: '#94a3b8',
      },
      option: {
        selectedBackground: 'transparent',
      },
    },
  },
  css: ({ dt }: any) => `
  .p-multiselect.custom-icon-only-multiselect {
    height: ${dt('multiselect.agility.custom.height')};
    width: ${dt('multiselect.agility.custom.width')};
    color: ${dt('multiselect.agility.custom.color')};
    border-width: ${dt('multiselect.agility.custom.border.width')};
    border-color: ${dt('multiselect.agility.custom.border.color')};
    border-radius: ${dt('multiselect.agility.custom.border.radius')};
    gap: 0;
  }
  .p-multiselect.custom-icon-only-multiselect:hover {
    border-color: ${dt('multiselect.agility.custom.border.hover.color')};
    color: ${dt('multiselect.agility.custom.hover.color')};
    background-color: ${dt('multiselect.agility.custom.hover.background')};
  }
  .p-multiselect.custom-icon-only-multiselect .p-multiselect-label-container {
    display: none;
  }
  .p-multiselect.custom-icon-only-multiselect .p-multiselect-dropdown {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: ${dt('multiselect.agility.custom.color')};
  }
  .p-multiselect.custom-icon-only-multiselect .p-multiselect-dropdown:hover {
    color: ${dt('multiselect.agility.custom.hover.color')};
  }
  `,
};
